// extracted by mini-css-extract-plugin
export default {"gradient":"TextStyles_gradient__CS84q"};